import Image from "@components/Image";
import Markdown from "@components/Markdown";
import cx from "classnames";
import styles from "./Overview.module.scss";
import { usePageContext } from "@providers/PageProvider";
import { artPage } from "@utils/helper";
import _ from "lodash";
const components = {
  p: (props: any) => <p {...props} className={cx(props.className, "mb-4")} />,
};
export default function OverviewAboutUs() {
  const { pageData } = usePageContext();
  const featured = artPage.formatFeatured(pageData);
  return (
    <>
      <section
        data-scroll-section
        className={cx("inner-large", styles.sectionOverview)}
      >
        <div className={cx("ama-sub-title", styles.overview)}>
          <span>{_.get(featured, "quoteContent")}</span>
          <span className="italic">{_.get(featured, "quoteSource")}</span>
        </div>
      </section>
      <section
        data-scroll-section
        className={cx("inner-large", styles.section)}
      >
        <div className={styles.boxImage}>
          <Image
            {..._.get(featured, "image")}
            alt={_.get(featured, "image.alt") || "Arts overview image"}
            scale={1}
            speed={0}
            wrapperProps={{ className: cx(styles.image) }}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className={cx(styles.content)}>
          <Markdown
            components={components}
            content={_.get(featured, "content")}
          />
        </div>
      </section>
    </>
  );
}
